import { Observable } from 'rxjs';

import { EvaluationQueryParams, EvaluationTemplate } from '../models/evaluation.model';
import { ListResponse } from '../models/utility.model';

export abstract class EvaluationGateway {
  abstract listEvaluationTemplates(params: EvaluationQueryParams): Observable<ListResponse<EvaluationTemplate>>;
}
